/**
 * Localiza a linha da grade correspondente ao ingresso urgente de hoje (modal de prioridade).
 */
export function encontrarIndiceLinhaDestaqueIngresso(linhas, destaque) {
	if (!destaque || !Array.isArray(linhas) || linhas.length === 0) return -1

	const diaId = String(destaque.diaId ?? "").trim()
	const data = String(destaque.data ?? "").trim()

	if (diaId) {
		const porDia = linhas.findIndex(
			(l) => String(l?.diaId ?? "").trim() === diaId && l?.slotIngresso
		)
		if (porDia >= 0) return porDia
	}

	if (data) {
		const porData = linhas.findIndex(
			(l) => String(l?.slotIngresso?.data ?? "") === data
		)
		if (porData >= 0) return porData
	}

	return linhas.findIndex((l) => {
		const s = l?.slotIngresso
		return s?.ehHoje === true && s?.podeIngressar === true
	})
}
